import React, { memo } from 'react';
import { AccordionItemsProps } from './types';

const Item = ({ children }: AccordionItemsProps) => (
  <div className={`clientos-ui-toolkit-accordion__item`}>{children}</div>
);

export default memo(Item);
